import * as React from 'react';
import { FilterProps } from '../filters';
import './enumFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Options } from '../Options/options';
import { EnumInput } from '../../EnumInput/enumInput';

const OPTIONS = [Op.is, Op.isNot, Op.isEmpty, Op.isNotEmpty];

const isSameType = (op1: Op, op2: Op) => {
  return [Op.is, Op.isNot].includes(op1) && [Op.is, Op.isNot].includes(op2);
};

type EnumFilterProps = FilterProps & { inlineMenu?: boolean };

interface Condition {
  [op: string]: { from?: string; to?: string } | boolean | string[] | string;
}

export const EnumFilter = ({
  filter,
  field,
  setFilter,
  opts
}: EnumFilterProps) => {
  if (!opts) opts = OPTIONS;
  const { op, val } =
    filter.conditions?.length == 1 && !!filter?.conditions[0]?.includeBlanks
      ? { op: Op.is, val: null }
      : parseCondition(filter.conditions, opts[0]);
  const showInput = op !== Op.isEmpty && op !== Op.isNotEmpty;
  const enumValues = field?.enumValues || {};

  const isCheckboxDisabled =
    !filter?.conditions ||
    filter?.conditions?.length < 0 ||
    (filter?.conditions?.length > 0 &&
      (Object.values(filter?.conditions[0])?.includes(null) ||
        (Object.values(filter?.conditions[0])?.length > 0 &&
          Object.values(filter?.conditions[0])[0]?.length === 0)));

  const isIncludingBlanks = filter?.conditions?.some(
    condition => 'includeBlanks' in condition
  );

  const handleSetFilter = React.useCallback(
    (newVals: string[]) => {
      const conditions: Condition[] = [{ [op]: newVals }];
      if (isIncludingBlanks && newVals?.length > 0)
        conditions.push({ includeBlanks: true });
      setFilter({
        ...filter,
        conditions
      });
    },
    [filter, op, isIncludingBlanks]
  );
  return (
    <div className="filter-box enum-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={opts}
          onSelect={o => {
            if ([Op.isEmpty, Op.isNotEmpty].includes(o)) {
              setFilter({ ...filter, conditions: [{ [o]: true }] });
            } else {
              let conditions: Condition[];
              if (isSameType(op, o)) {
                conditions = [{ [o]: val }];
              } else {
                conditions = [{ [o]: null }];
              }
              if (isIncludingBlanks && o != Op.isEmpty && o != Op.isNotEmpty) {
                conditions.push({ includeBlanks: true });
              }
              setFilter({ ...filter, conditions });
            }
          }}
          selected={op}
        />
        {[Op.is, Op.isNot].includes(op) && (
          <div className="checkbox-container">
            <input
              type="checkbox"
              className="checkbox"
              checked={isIncludingBlanks}
              disabled={isCheckboxDisabled}
              onChange={() => {
                const conditions: Condition[] =
                  filter?.conditions?.filter(
                    condition => !('includeBlanks' in condition)
                  ) || [];
                if (!isIncludingBlanks)
                  conditions.push({ includeBlanks: true });
                setFilter({
                  ...filter,
                  conditions
                });
              }}
            />
            <div>Include Blanks</div>
          </div>
        )}
      </div>
      <div>
        {showInput && (
          <EnumInput
            enumValues={enumValues}
            selected={val}
            onChange={handleSetFilter}
            multiple
            inlineMenu
          />
        )}
      </div>
    </div>
  );
};
